<template>
  <div id="footer" class="footer">
    <FooterTwo v-if="tln == 'two'"></FooterTwo>
    <FooterThree v-if="tln == 'three'"></FooterThree>
    <FooterFour v-if="tln == 'four'"></FooterFour>
    <img src="../../assets/images/top_btn.png" alt="" class="back_top_btn" @click="backTop" />
  </div>
</template>

<script>
  import FooterTwo from "../FooterTwo.vue";
  import FooterThree from "../FooterThree.vue";
  import FooterFour from "../FooterFour.vue";
  export default {
    name: "Footer",
    props: ["tln"],
    data: function() {
      return {}
    },
    components: { FooterTwo, FooterThree, FooterFour },
    mounted:function(){

    },
    methods: {
      // 滚动条回到顶部
      backTop() {
        //console.log(document.querySelectorAll(".container")[0].scrollTop);
        let dom = document.querySelectorAll(".container")[0];
        dom.pageYOffset = 0;
        dom.scrollTop = 0;
      }
    }
  }
</script>

<style lang="less">
  .footer_content {
    word-break: normal;

    .b_more {
      width: 100%;
      text-align: center;
      border-top: solid thin rgba(0,0,0,0.85);
      padding: 5.208vw 0 2.865vw 0;
    }

    .fc_news {
      display: flex;
      justify-content: space-between;
      width: 100%;
      /* overflow: hidden; */
      li {
        position: relative;
        z-index: 1;
        .news_item_link {
          color: white;
          display:block;
          width: 100%;
          height: 100%;
          img {
            width: 100%;
            height: 100%;
          }
          .new_text_wrapper {
            width: 100%;
            height: 100%;
            position: absolute;
            z-index: 1;
            top: 0;
            left: 0;
            transform: translateY(100%);
            transition: all .3s ease-out;
            -moz-transition: all .3s ease-out; /* Firefox 4 */
            -webkit-transition: all .3s ease-out; /* Safari 和 Chrome */
            -o-transition: all .3s ease-out; /* Opera */
            .news_text{
              font-size: 0.667em;
              text-align: left;
              width: 100%;
              height: 100%;
              box-sizing: border-box;
              padding: 1.5em 2.5em;
              position: absolute;
              z-index: 3;
              top: 0;
              left: 0;
            }
            .b_block {
              width: 100%;
              height: 100%;
              position: absolute;
              z-index: 2;
              top: 0;
              left: 0;
              background-color: rgba(0, 0, 0, 0.5);
            }
          }
        }
        &:hover {
          .news_item_link {
            .new_text_wrapper {
              transform: translateY(0);
            }
          }
        }
      }
    }

    .list_container {
      font-family: "ULTS";
      display: flex;
      justify-content: space-between;
      font-size: 0.75em;
      padding: 4.583em 0 8.333em 0;
      border-top: solid thin rgba(0,0,0,0.85);
      margin-top: 4.583em;
      letter-spacing: normal;
      word-spacing: normal;
      .fp_bl {
        border-bottom: solid thin rgba(0,0,0,0.85);
      }
      &>li {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .logo img {
          height: 2em;
        }
        .fb {
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          li {
            margin-bottom: 0.5em
          }
        }
        p {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: baseline;
          margin: 0;
          span {
            display: block;
            margin-bottom: 0.2em;
          }
          .fp_title {
            margin-bottom: 1em;
            font-weight: bold;
          }
        }
      }
    }
  }
  .back_top_btn {
    display: block;
    width: 1.5625em;
    position: fixed;
    z-index: 100;
    right: 5.208vw;
    bottom: 5.208vw;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/Footer.vue